import Vue from 'vue';
import { hasPermissions } from '@/utils';

// Register a global custom directive called `v-focus`
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted(el) {
    // Focus the element
    el.focus();
  },
});

const insertComment = (el, vnode) => {
  // replace HTMLElement with comment node
  const comment = document.createComment(' ');
  Object.defineProperty(comment, 'setAttribute', {
    value: () => undefined,
  });
  vnode.elm = comment;
  vnode.text = ' ';
  vnode.isComment = true;
  vnode.context = undefined;
  vnode.tag = undefined;
  vnode.data = {
    ...vnode.data,
    directives: undefined,
  };

  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el);
  }
};

Vue.directive('has-permission', (el, binding, vnode) => {
  const { can, permissions } = binding.value;
  if (!(hasPermissions(can, permissions))) {
    insertComment(el, vnode);
  }
});
